import { render } from "./PastPage.vue?vue&type=template&id=5263e970&scoped=true"
import script from "./PastPage.vue?vue&type=script&lang=js"
export * from "./PastPage.vue?vue&type=script&lang=js"

import "./PastPage.vue?vue&type=style&index=0&id=5263e970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5263e970"]])

export default __exports__